import type { ButtonHTMLAttributes } from 'react';
import styles from './Button.module.css';

/** Eigenschaften des Buttons: Standard-Button-Attribute plus Darstellungsvariante. */
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Darstellungsvariante: `primary` für die Hauptaktion, `secondary` für Nebenaktionen. */
  variant?: 'primary' | 'secondary';
}

/**
 * Einheitlicher Button. Standardmäßig `type="button"`, damit er in Formularen nicht
 * versehentlich abschickt.
 * @param props Button-Attribute und Variante.
 */
export function Button({ variant = 'primary', className, type = 'button', ...rest }: ButtonProps) {
  const classes = [styles.button, styles[variant], className].filter(Boolean).join(' ');
  return <button type={type} className={classes} {...rest} />;
}
